// Global, target-market-aware currency formatting.

const CURRENCIES = {
  INR: { symbol: "₹", scale: "in" },
  USD: { symbol: "$", scale: "west" },
  AUD: { symbol: "A$", scale: "west" },
  GBP: { symbol: "£", scale: "west" },
  CAD: { symbol: "C$", scale: "west" },
  NZD: { symbol: "NZ$", scale: "west" },
  SGD: { symbol: "S$", scale: "west" },
  AED: { symbol: "AED ", scale: "west" },
  ZAR: { symbol: "R", scale: "west" },
  EUR: { symbol: "€", scale: "west" },
  JPY: { symbol: "¥", scale: "west" },
  BRL: { symbol: "R$", scale: "west" },
  MXN: { symbol: "MX$", scale: "west" },
};

// Accepts a currency code string ("USD") OR a currency object ({code,symbol}).
function resolve(currency) {
  if (currency && typeof currency === "object") {
    const meta = CURRENCIES[currency.code] || {};
    return { code: currency.code || "USD", symbol: currency.symbol || meta.symbol || "$", scale: meta.scale || "west" };
  }
  const code = currency || "INR";
  const meta = CURRENCIES[code] || { symbol: "$", scale: "west" };
  return { code, symbol: meta.symbol, scale: meta.scale };
}

export function shortMoney(n, currency = "INR") {
  if (n == null || isNaN(n)) return "—";
  const { symbol, scale } = resolve(currency);
  if (scale === "in") {
    if (n >= 10000000) return `${symbol}${(n / 10000000).toFixed(1).replace(/\.0$/, "")}Cr`;
    if (n >= 100000) return `${symbol}${(n / 100000).toFixed(1).replace(/\.0$/, "")}L`;
    if (n >= 1000) return `${symbol}${Math.round(n / 1000)}K`;
    return `${symbol}${n}`;
  }
  if (n >= 1000000) return `${symbol}${(n / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1000) return `${symbol}${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}K`;
  return `${symbol}${n}`;
}

export function moneyRange(min, max, currency = "INR") {
  return `${shortMoney(min, currency)}–${shortMoney(max, currency)}`;
}

export function fullMoney(n, currency = "INR") {
  if (n == null) return "—";
  const { symbol } = resolve(currency);
  return `${symbol}${n.toLocaleString("en-US")}`;
}

export function scoreColor(score) {
  if (score >= 78) return "#10b981";
  if (score >= 52) return "#f59e0b";
  return "#64748b";
}

export function priorityStyles(label) {
  if (label === "HIGH PRIORITY")
    return { text: "text-emerald-400", bg: "bg-emerald-500/10", border: "border-emerald-500/30", dot: "#10b981" };
  if (label === "MEDIUM PRIORITY")
    return { text: "text-amber-400", bg: "bg-amber-500/10", border: "border-amber-500/30", dot: "#f59e0b" };
  return { text: "text-slate-400", bg: "bg-slate-500/10", border: "border-slate-600/30", dot: "#64748b" };
}
